var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _a;
import { IdErrorCore } from "../../constants/IdErrorCore";
import { TypeActionError } from "./actionError";
var initial = (_a = {},
    _a[IdErrorCore.CoopInvitePlayerErrors] = [],
    _a[IdErrorCore.TextErrors] = [],
    _a[IdErrorCore.UnhandledErrors] = [],
    _a);
export var reducerError = function (state, action) {
    if (state === void 0) { state = initial; }
    var _a, _b, _c;
    switch (action.type) {
        case TypeActionError.Throw:
            return __assign({}, state, (_a = {}, _a[action.errorKey] = state[action.errorKey].concat([action.statusCode]), _a));
        case TypeActionError.Resolve:
            return __assign({}, state, (_b = {}, _b[action.errorKey] = state[action.errorKey].slice(0, state[action.errorKey].length - 1), _b));
        case TypeActionError.ResolveAll:
            return __assign({}, state, (_c = {}, _c[action.errorKey] = [], _c));
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/errors/reducerError.ts
// module id = 2527
// module chunks = 3